/**
 * @classdesc English Language Pack
 * @desc This class will used to translate tokens into the English language.
 * @namespace Languages.English
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.English
 */
export const dictionary = {
	'years'   : 'Years',
	'months'  : 'Months',
	'days'    : 'Days',
	'hours'   : 'Hours',
	'minutes' : 'Minutes',
	'seconds' : 'Seconds'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.English
 */
export const aliases = ['en', 'en-us', 'english'];
